import { CARGAR_CUENTASBANCARIAS, CARGAR_ITEMS_PLANILLA_DEPCHEQUE, ACTUALIZARSELECCION_CHEQUESDISTRIBUIDOS,
    CARGAR_PLANILLA_DEPCHEQUE, CARGAR_PLANILLAS_DEPCHEQUE } from '../actions/bancos/actionTypes';

const bancosReducer = (state={ cuentasBancarias:[], itemsPlanillaDepCheque:[], chequesDistribSeleccionados: [],
        planillaDepCheque: {}, planillasDepCheque: []}, action) => {
    switch(action.type){
        case CARGAR_CUENTASBANCARIAS:
            return {...state, cuentasBancarias: action.data};
        case CARGAR_ITEMS_PLANILLA_DEPCHEQUE:
            return {...state, itemsPlanillaDepCheque: action.data };
        case ACTUALIZARSELECCION_CHEQUESDISTRIBUIDOS:
            return {...state, chequesDistribSeleccionados: action.data };
        case CARGAR_PLANILLA_DEPCHEQUE:
            return {...state, planillaDepCheque: action.data };
        case CARGAR_PLANILLAS_DEPCHEQUE:
            return {...state, planillasDepCheque: action.data };
        default:
            return state;
    }
};

export default bancosReducer;